﻿document.querySelectorAll('.js--uform form').forEach(function (elem) {
    elem.addEventListener("submit", function (e) {
        if(e.target.querySelectorAll(".input-validation-error").length == 0){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "trackEvent",
                "trackCategory": "Form",
                "trackAction": "Submit",
                "trackLabel": e.target.querySelector(".umbraco-forms-caption").innerText
            });
        }
    });
});